import { Component, Input } from '@angular/core';

import { FrontendModalService } from '@tablesready/frontend-modal';
import { AppIcon } from '@tablesready/frontend-icons';

@Component({
  selector: 'quoted-time-modal',
  templateUrl: './quoted-time-modal.component.html',
})
export class QuotedTimeModal {
  @Input() defaultQuotedTime: number;
  icon = AppIcon;
  constructor(private readonly modalController: FrontendModalService) {}

  submit(): void {
    this.modalController.dismiss({ eventType: 'save' });
  }

  cancel(): void {
    this.modalController.dismiss({ eventType: 'cancel' });
  }
}
